
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton, AppFormRow, AppSelect } from '@/components';
import { useQuestItemList } from '@/modules/quest/item/model/list';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { QuestItemGameType } from '@/modules/quest/item/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_QUEST.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton, AppFormRow, AppSelect },
    setup() {
        const { list, total, fetchList, query, questTypeOptionWithAll, actions } = useQuestItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Avg Game', key: 'avgGameRange' },
                { type: TableColumnType.Text, label: 'Bet', key: 'betRange' },
                { type: TableColumnType.Option, label: 'Game Type', key: 'gameType', options: QuestItemGameType },
                { type: TableColumnType.Text, label: 'Game', key: 'game' },
                { type: TableColumnType.Text, label: 'Reward', key: 'reward' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_QUEST.ITEM.EDIT, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-clock',
                        theme: 'info',
                        tooltip: 'Edit time',
                        to: { name: ROUTE_NAME_QUEST.ITEM.TIME, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_QUEST.ITEM.TRANSLATE, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'info',
                        tooltip: 'Enable next',
                        onclick: () => actions.enableNext(row.id)
                    }),
                    canShow: (row: any) => row.canEnableNext,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'info',
                        tooltip: 'Disable next',
                        onclick: () => actions.disableNext(row.id)
                    }),
                    canShow: (row: any) => row.canDisableNext,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, query, questTypeOptionWithAll, ROUTE_NAME_QUEST };
    }
});
